export default function ServicesHero() {
  return (
    <section className="relative py-24 bg-gray-900">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c8a0f14a0a9fe541ed7d392104ef7ce4.jpg"
          alt="Professional parking lot services"
          className="w-full h-full object-cover object-top opacity-30"
        />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-yellow-400 uppercase tracking-wider text-sm font-semibold mb-4">
          What We Do
        </p>
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Oswald, sans-serif' }}>
          Complete Parking Lot Services
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
          From striping to sealcoating, we provide comprehensive pavement maintenance solutions for commercial properties throughout Oklahoma City.
        </p>
      </div>
    </section>
  );
}
